module.exports = __webpack_public_path__ + "img/star1.71b640dd.png";